import React from 'react';
import "./PartnersBanner.scss";
import {useNavigate} from "react-router-dom";

function PartnersBanner(props) {
	const navigate = useNavigate();

	const linkToPartners = () => {
		navigate("/products");
		window.scrollTo(0,0);
		props.setSelectedLink(2);
	}
	return (
		<div className="partners-banner">
			<div className="container">
				<div className="banner-wrapper">
					<h1>Наши продукты</h1>
					<p>Мы создаём сервисы, которые упрощают платежи, оформление виз и автоматизируют бизнес.</p>
					<button onClick={linkToPartners}>
						Подробнее
					</button>
				</div>
			</div>
		</div>
	);
}

export default PartnersBanner;